"use client";

import { useState } from "react";

export default function CopyAddress({ address }: { address: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      className="group inline-flex items-center gap-2 mono text-sm bg-[var(--surface-2)] hover:bg-[var(--accent-soft)] border border-[var(--border)] hover:border-[var(--accent)] text-[var(--foreground)] px-2.5 py-1 rounded-md transition-colors"
    >
      <span>{address}</span>
      <span className="text-[10px] uppercase tracking-wider font-semibold text-[var(--muted)] group-hover:text-[var(--accent-strong)]">
        {copied ? "복사됨" : "복사"}
      </span>
    </button>
  );
}
